import { setCookie, getCookie, deleteCookie } from './cookie';
import http from './api/http';

export function isLoggedIn() {
    if (!getCookie('access_token')) {
        return false;
    }
    return true;
}

export function saveTokens(data) {
    const keep_logged = JSON.parse(window.localStorage.getItem('remember_me'));
    const { access_token } = data;

    setCookie('access_token', access_token, {}, keep_logged);

    // Change Authorization header for the next requests
    http.defaults.headers['Authorization'] = `Bearer ${access_token}`;
}

export function deleteTokens() {
    deleteCookie('access_token');
}
